import styled, { css } from "styled-components"
import media from "src/styles/media"
import Link from "src/components/util/TransitionLink"
import Img from "gatsby-image"

export const BlogItemWrapper = styled.article`
  display: block;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
  max-width: 330px;
  margin: 0 auto;
  border-radius: 15px;
  box-shadow: 6px 4px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.4s;

  &:hover {
    text-decoration: none;
    transform: scale(1.03);
    box-shadow: 7px 8px 14px rgba(0, 0, 0, 0.21);
  }
`

const BlogItemImgCSS = css`
  width: 100%;
  height: 190px;
  transition: all 0.4s;
  z-index: 1;
  object-fit: cover;
  object-position: center center;

  ${media.lessThan("sm")`
        height: 140px;
    `}
`

export const BlogItemImgFluid = styled(Img)`
  ${BlogItemImgCSS}
`

export const BlogItemImg = styled.img`
  ${BlogItemImgCSS}
`

export const BlogItemCaption = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 52%;
  padding: 35px 25px 17px 35px;
  color: var(--dark);
  text-align: left;

  ${media.lessThan("lg")`
        padding: 25px 15px 25px 25px;
    `}

  ${media.lessThan("sm")`
        height: 58%;
    `}
`

export const BlogItemTitle = styled.h1`
  font-size: 26px;
  margin-bottom: 0;
  font-weight: 600;
  z-index: 2;
  line-height: 1;
  margin-bottom: 13px;

  ${media.lessThan("md")`
        font-size: 24px;
    `}

  ${media.lessThan("sm")`
        font-size: 20px;
    `}
`

export const BlogItemDesc = styled.p`
  font-weight: 300;
  font-size: 15px;
  line-height: 1.1;
  margin-bottom: 30px;
  font-weight: normal;
  opacity: 0.8;
  z-index: 2;

  ${media.lessThan("sm")`
        font-size: 15px;
    `}
`

export const BlogItemMore = styled(Link)`
  font-weight: 300;
  font-size: 19px;
  margin-bottom: -6px;
  font-weight: normal;
  opacity: 0.8;
  z-index: 2;
  margin-top: auto;
`
